import type { CurrentStoredUserData } from '#features/UserData/CurrentStoredUserData'

export type UserDataVersion<TVersion = string> = TVersion & { __userDataVersionBrand: never }

export const userDataType = 'maic-frontend-user-data' as const
export type UserDataType = typeof userDataType

export type StoredUserData<TUserData, TVersionString extends UserDataVersion, TType extends string = UserDataType> = TUserData & {
  __version: TVersionString
  __updatedAt: Timestamp
  __type: TType
  __maicVersion: string
}

export function isStoredUserData(storedData: unknown): storedData is CurrentStoredUserData {
  return (
    typeof storedData === 'object' && storedData !== null && '__version' in storedData && '__type' in storedData && storedData.__type === userDataType
  )
}
